import * as angular from "angular";
import {IController} from "angular";
import {
  AgentInventoryConfigModel,
  AgentInventorySetting
} from "../../../agent-inventory/angular/models/inventory-setting.model";
import {AgentInventoryDialogService} from "../../../agent-inventory/angular/services/agent-inventory-dialog.service";
import {DepotModel} from "../../angular/models/depot.model";
import {DepotsService} from "../../services/depots-service.service";

export class DepotInventoryConfigViewComponent implements IController {

  depot: DepotModel;

  constructor(private depotsService: DepotsService, private agentInventoryDialogService: AgentInventoryDialogService) {

  }

  $onInit() {
    if (!this.depot?.agentInventoryConfig) {
      this.depot.agentInventoryConfig = {settings: []};
    }
  }

  $onChanges(changes: angular.IOnChangesObject) {

  }

  onAddConfiguration($event) {
    const excludePackageIds = this.depot.agentInventoryConfig.settings.map((s) => {
      return s.packageType;
    })
    this.agentInventoryDialogService.openAgentInventorySetting($event, undefined, excludePackageIds)
      .then((settingToCreate: AgentInventorySetting) => {
        const depotCopy = angular.copy(this.depot);
        depotCopy.agentInventoryConfig.settings.push(settingToCreate);

        this._updateDepot(depotCopy);
      })
  }

  onEditSetting(setting: AgentInventorySetting, index: number) {
    const currentPackageTypes = this.depot.agentInventoryConfig.settings.map((s) => {
      return s.packageType;
    })
    const excludePackageTypes = currentPackageTypes.filter((packageType) => {
      return packageType !== setting.packageType;
    })
    this.agentInventoryDialogService.openAgentInventorySetting(undefined, setting, excludePackageTypes)
      .then((updatedSetting: AgentInventorySetting) => {
        const depotCopy = angular.copy(this.depot);
        depotCopy.agentInventoryConfig.settings.splice(index, 1, updatedSetting);

        this._updateDepot(depotCopy);
      })
  }

  onRemoveSetting(index: number) {
    const depotCopy = angular.copy(this.depot);
    depotCopy.agentInventoryConfig.settings.splice(index, 1);

    this._updateDepot(depotCopy);
  }

  private _updateDepot(depot: DepotModel) {
    this.depotsService.updateOne(depot.id, depot);
  }


}

angular
  .module('bringoz.admin.depots')
  .component('depotInventoryConfigView', {
    bindings: {
      depot: '<'
    },
    template: require('./depot-inventory-config-view.html').default,
    controller: DepotInventoryConfigViewComponent
  });
